import COLORS from "scss/colors.module.scss";

let cellClickCount = 0;

export default function BooleanColumnRenderer(params) {

  function getCheckBox() {
    if(params.data?.row_id == "+"){
      return `<div/>`
    }
    if (params.value === "1") {
      return `<svg
        xmlns="http://www.w3.org/2000/svg"
        width="17.6"
        height="17.6"
        viewBox="0 0 16 16"
        class="flex-none"
        style="shapeRendering: geometricprecision"
      >
        <path
          fillRule="evenodd"
          fill=${COLORS.THEME_COLOR}
          d="M5.944 12.305a1.031 1.031 0 0 0 1.433-.009l5.272-5.181A1.483 1.483 0 0 0 12.661 5a1.468 1.468 0 0 0-2.109.025L7.008 8.701a.465.465 0 0 1-.685-.01l-.587-.641A1.42 1.42 0 0 0 3.661 8a1.473 1.473 0 0 0 .017 2.106l2.266 2.199z"
        ></path>
      </svg>`;
    } else if (params.value === "0" || params.data?.row_id !== "+") {
      return `<svg 
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24" 
                width="17.6"
                height="17.6"
                >
                <path 
                  fillRule="evenodd"
                  fill=${COLORS.THEME_COLOR}
                  d="M19 5v14H5V5h14m0-1H5c-1.1 0-1 .9-1 1v14c0 1.1.9 1 1 1h14c1.1 0 1-.9 1-1V5c0-1.1-.9-1-1-1z"
                </path>
              </svg>`;
    }
    return `<div/>`
  }

  function clickHandler() {
    cellClickCount = cellClickCount + 1;
    if (
      cellClickCount > 1 &&
      params.store.prevClickedCellRowId ===
        params.api.getFocusedCell().rowIndex &&
      params.store.prevClickedCellColumnId ===
        params.api.getFocusedCell().column.colDef.cellRendererParams.columnId
    ) {
      params.api.startEditingCell({
        colKey: params.colDef.colId,
        rowIndex: params.rowIndex,
      });
      cellClickCount = 0;
    }
  }

  let booleanRenderElement = document.createElement("div");
  booleanRenderElement.className = "booleanRenderer";
  booleanRenderElement.style =
    "width:" +
    (Number(params.colDef.width) - 17) +
    "px;\
    height:" +
    (Number(params.node.rowHeight) - 4) +
    "px;";
  booleanRenderElement.onclick = clickHandler;
  booleanRenderElement.innerHTML = getCheckBox();

  return booleanRenderElement;
}